// extracted by mini-css-extract-plugin
export default {"container":"List_container__HF9-U","empty":"List_empty__J0tPF"};